const state = () => {
  return {
    sc_work_pivots: [],
    sc_work_hierarchy: [],
    sc_work_pivot: {},
    sc_work_pivot_filters: {},
  }
}

export default state;
